"use strict";

require("../../style/index.less");

require("./index.less");


//////////////////
// WEBPACK FOOTER
// ../~/antd/lib/tree/style/index.js
// module id = 644
// module chunks = 1